import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import pjudLogo from './integrationsLogo/pjudLogo.png';
import { useLanguage } from '../../../../context/LanguageContext';
import { normalizeSupportedLanguage } from '../../../../utils/createScopedI18n';
import { integrationsI18n } from './i18n';

export default function PjudModal({
  Modal,
  Input,
  show,
  onClose,
  onSave,
  onUnlink,
  initialData,
  isSaving = false,
}) {
  const { language } = useLanguage();
  const integrationsLanguage = normalizeSupportedLanguage(language);
  const { t } = useTranslation(undefined, { i18n: integrationsI18n });

  const [form, setForm] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    integrationsI18n.changeLanguage(integrationsLanguage);
  }, [integrationsLanguage]);

  useEffect(() => {
    if (!show) return;
    const isActive = initialData?.active === true;
    if (isActive) {
      const username =
        initialData?.account ||
        initialData?.username ||
        initialData?.userName ||
        initialData?.usuario ||
        '';
      const password =
        initialData?.password ||
        initialData?.claveUnica ||
        initialData?.clave ||
        '';
      setForm({ username, password });
    } else {
      setForm({ username: '', password: '' });
    }
    setShowPassword(false);
  }, [show, initialData]);

  const isValid = useMemo(() => {
    return form.username.trim().length > 0 && form.password.trim().length > 0;
  }, [form.username, form.password]);

  const onChange = (key) => (event) =>
    setForm((prev) => ({ ...prev, [key]: event.target.value }));

  if (!Modal || !Input) return null;

  const isActive = initialData?.active === true;

  return (
    <Modal
      show={show}
      onClose={onClose}
      primaryBtnTxt={
        isSaving ? t('integrations_modal_saving') : t('integrations_modal_save')
      }
      primaryBtnAction={() => onSave?.(form)}
      disabledPrimaryBtn={!isValid || isSaving}
      secondaryBtnTxt={isActive ? t('integrations_modal_unlink') : null}
      secondaryBtnAction={isActive ? () => onUnlink?.() : null}
      ctaAligment='right'
      width='520px'
    >
      <div className='d-flex flex-column gap-3'>
        <div className='d-flex gap-2 align-items-center mb-4'>
          <img
            className='integration-card__logo'
            src={pjudLogo}
            alt={t('integrations_modal_logo_alt')}
          />
          <h3 className='integration-card__title mb-0'>
            {t('integrations_modal_title_pjud')}
          </h3>
        </div>
        <Input
          label={t('integrations_modal_rut_label')}
          placeholder={t('integrations_modal_rut_placeholder')}
          value={form.username}
          onChange={onChange('username')}
        />
        <Input
          label={t('integrations_modal_password_label')}
          placeholder={t('integrations_modal_password_placeholder')}
          value={form.password}
          onChange={onChange('password')}
          type={showPassword ? 'text' : 'password'}
          icon={showPassword ? 'eye' : 'eyeSlash'}
          iconOnClick={() => setShowPassword((prev) => !prev)}
        />
      </div>
    </Modal>
  );
}
